import cs_vuetify from "vuetify/src/locale/cs.ts";
import cs_vee from "vee-validate/dist/locale/cs";

let lang = {
  lang: {
    iso: "cs-CZ",
    decimal_separator: ","
  },

  common: {
    position: "Pozice",
    driver: "Řidič",
    ride: "Jízda",
    vehicle_filter: "Filtr vozidel",
    remaining: "zbývá",
    date: "Datum",
    time: "Čas",
    currency: "Měna",
    service_is: "za",
    service_over: "přes",
    select_all_filtered_itms: "Vybrat všenchy fitrované položky",
    select_none_filtered_itms: "Odebrat všechny filtrované položky",
    vehicle: {
      vehicle: "Sledovat vozidlo",
      history: "Historie",
      logbook: "Kniha jízd",
      refueling: "Tankování",
      state_ok: "komunikuje",
      state_fail: "nekomunikuje"
    },
    or: "nebo",
    last_timestamp: "Čas poslední komunikace",
    vehicle_ids: "Identifikátory vozidla (ID vozidla, a seriové číslo zařízení)",
    fast_filter: "Rychlý filtr",
    empty_list_with_add: "Seznam je prázdný.<br/>Tlačítkem <b>Přidat</b> vložíte novou identifikaci.",
    door: "dvěře",
    panic: "PANIC"
  },

  main_menu: {
    actions: {
      company_select: "Firma",
      groupset_select: "Skupina",
      map: "Mapa",
      map_preview: "Přehled vozidel",
      plan: "Plán zakázek",
      vehicle_select: "Vybrat vozidlo",
      find: "Vyhledat vozidlo",
      refueling: "Vložit tankování",
      vehicles: "Vozidla",
      persons: "Osoby",
      contracts: "Zakázky",
      subjects: "Společnosti",
      groupsets: "Skupiny",
      sharings: "Sdílení polohy",
      companies: "Firmy"
    },
    reports: {
      title: "Výkazy"
    },
    logout: "Odhlásit"
  },

  map: {
    tooltip: {
      right_panel: "Zobrazit/skrýt pravý panel",
      refresh: "Aktualizovat stav vozidel. Stav se automaticky aktualizuje každou minutu.",
      zoom_in: "Přiblížit",
      zoom_out: "Oddálit",
      default_view: "Počáteční zobrazení mapy",
      map_layer: "Mapový podklad",
      company_current: "Vybraná firma: ",
      control: {
        prev_week: "Předchazející týden",
        next_week: "Následující týden",
        prev_day: "Předchazející den",
        next_day: "Následující den",
        toggle_graph: "Zobrazit/skrýt graf",
        options: "Parametry zobrazení"
      },
      vehicle_popup: {
        tachograph_day: "Denní doba jízdy",
        tachograph_week: "Týdenní doba jízdy",
        invalid_tachograph_data: "Neaktuální data tachografu"
      }
    },
    title: {
      base: "{name}",
      satellite: "{name} (letecká)",
      traffic: "{name} (provoz)"
    },
    panel: {
      tooltip: {
        vehicle: "Detail vozidla",
        history: "Historie vozidla",
        logbook: "Kniha jízd",
        events: "Události vozidla",
        contracts: "Zakázky vozidla",
        refueling: "Tankování",
        service: "Údržba",
        close: "Zpět na online"
      },
      online: {
        action: {
          logbook: "Kniha jízd",
          vehicle_update: "Úprava provozních parametrů",
          vehicle_edit: "Úprava vozidla"
        },
        tooltip: {
          show_hide: "Zobrazit/skrýt vozidlo na mapě",
          keep_on_map: "Udržovat vybraná vozidla viditelná na mapě",
          show_all: "Zobrazit všechna vyfiltrovaná vozidla",
          hide_all: "Skrýt všechna vyfiltrovaná vozidla",
          update: "Úprava provozních parametrů",
          edit: "Upravit vozidlo",
          log: "Zobrazit log vozidla",
          more: "Další operace"
        },
        service: "servis"
      },
      history: {
        column: {
          from_ts: "Od",
          to_ts: "Do",
          duration: "Doba",
          from: "Odkud",
          to: "Kam",
          type_driver: "Typ jízdy • řidič • pořadí",
          odometer: "Tacho.",
          distance: "Vzdá.",
          consumption: "Spotřeba"
        },
        menu: {
          cancel: "Zrušit výběr",
          print_graph: "Vytisknout graf",
          export_graph: "Export do PDF"
        },
        ride_menu: {
          "select": "Vybrat jízdu",
          "update": "Upravit jízdu"
        },
        show_all: "Zobrazit i nulové jízdy",
        graph: {
          altitude: {
            title: "Nadmořská výška",
            axle: "Nadmořská výška [m]",
            unit: "m.n.m"
          },
          speed: {
            title: "Rychlost",
            axle: "Rychlost [km/h]",
            unit: "km/h"
          },
          km: {
            title: "Stav tachometru",
            axle: "Tachometr [km]",
            unit: "km"
          },
          tank: {
            title: "Stav nadrží",
            axle: "Stav nadrží [l]",
            unit: "l"
          },
          weight: {
            title: "Zatížení náprav",
            axle: "Zatížení náprav [t]",
            unit: "t"
          },
          rpm: {
            title: "Otáčky",
            axle: "Otáčky [rpm]",
            unit: "rpm"
          },
          temp1: {
            title: "Teplota 1",
            axle: "Teplota 1 [℃]",
            unit: "℃"
          },
          temp2: {
            title: "Teplota 2",
            axle: "Teplota 2 [℃]",
            unit: "℃"
          }
        }
      },
      logbook: {
        title: "Kniha jízd",
        tooltip: {
          report_logbook: "Zobrazit knihu jizd",
          report_performance: "Zobrazit výkon vozidla",
          report_machine_performance: "Zobrazit výkon stroje"
        },
        column: {
          from_ts: "Od",
          to_ts: "Do",
          from: "Odkud",
          to: "Kam",
          odometer: "Tachometr",
          distance: "Vzdálenost",
          tank_level: "Nádrže",
          tank_diff: "Změna"
        },
        ride_menu: {
          "select": "Vybrat jízdu",
          "update": "Upravit jízdu"
        }
      },
      refueling: {
        title: "Tankování",
        tooltip: {
          report_refueling: "Zobrazit výkaz tankování"
        },
        column: {
          ts: "Čas",
          place: "Místo",
          driver: "Řidič",
          quantum_m: "Množství",
          quantum_d: "Dok. množsví",
          amount: "Cena"
        },
        ride_menu: {
          "select": "Vybrat jízdu",
          "update": "Upravit jízdu"
        }
      },
      events: {
        title: "Události",
        column: {
          ts: "Čas",
          event: "Událost",
          state: "Stav",
          person: "Osoba"
        },
        context_menu: {
          "select": "Zobrazit udalost na mapě"
        }
      },
      service: {
        title: "Údržba",
        tooltip: {
          add_plan: "Vytvořit nový plán údržby",
          add_service: "Vložit údržbu"
        },
        column: {
          plan: {
            name: "Plán",
            repetition: "Opakování",
            next: "Nastane"
          },
          service: {
            name: "Údržba",
            date: "Datum",
            state: "Stav"
          }
        },
        plan_menu: {
          select: "Vybrat plán",
          update: "Upravit plán",
          delete: "Vymazat plán",
          addservice: "Přidat údržbu"
        },
        service_menu: {
          update: "Upravit údržbu",
          delete: "Vymazat údržbu"
        },
        delete_plan_msg: "Opravdu chcete vymazat plán: <b>{plan}</b>?",
        delete_with: "Vymazat včetně údržby",
        delete_service_msg: "Opravdu chcete vymazat údržbu: <b>{service}</b>?"
      },
      contracts: {
        title: "Zakázky",
        column: {
          name: "Název",
          subject: "Organizace",
          from: "Od",
          to: "Do",
          distance: "Vzdálenost",
          duration: "Doba",
          amount: "Cena",
          amount_km: "Cena za km"
        },
        contract_menu: {
          "select": "Zobrazit na mapě",
          "update": "Upravit zakázku"
        },
        noride: "Žádná naměřená jízda"
      },
      vehicle: {
        base: {
          name: "Název",
          type: "Typ",
          location: "Pozice",
          timestamp: "Čas",
          speed: "Rychlost",
          odometer: "Tachometr",
          enginehours: "Stav motohodin",
          driver_quality: "Moment. kval. řízení",
          coords: "Souřadnice",
          coords_google_map: "Otevřit v Google maps",
          coords_google_clipboard: "Kopirovat URL do schránky",
          vcc: "Stav baterie",
          temp1: "Teplota 1",
          temp2: "Teplota 2",
          toservice: "Servis za"
        },
        info: {
          title: "Informace o vozidle",
          numeric_plate: "SPZ",
          vin: "VIN",
          manufacture_year: "Rok výroby",
          enorm: "Hom. emisí",
          category: "Kategorie",
          type_design: "Typ. označení",
          device_code: "Zařízení",
          id: "ID"
        },
        "service-plans": {
          title: "Údržba"
        },
        ride: {
          last_title: "Poslední jízda",
          active_title: "Aktuální jízda",
          type: "Typ",
          state: "Stav",
          from: "Odkud",
          to: "Kam",
          distance: "Vzdálenost",
          enginehours: "Motohodiny",
          elevation: "Převýšení",
          driver_quality: "Kvalita řízení",
          consumption: "Spotřeba paliva",
          max_speed: "Max. rychlost",
          over_speed: "Překročení rychlosti",
          motor_idle: "Motor naprázdno",
          axle_load: "Celkové zatížení",
          vcc: "Stav baterie",
          driver: "Řidič",
          tanks: "Nádrže",
          note: "Poznámka"
        },
        tanks: {
          title: "Jednotlivé nádrže",
          tank1: "Nádrž 1",
          tank2: "Nádrž 2",
          tank3: "Nádrž 3",
          tank4: "Nádrž 4"
        },
        axleweight: {
          title: "Zatížení náprav"
        },
        tachograph: {
          history: "Historie",
          history_tooltip: "Zobrazit historii tachografu",
          title: "Tachograf",
          card_id: "Číslo karty",
          last_update: "Aktualizace",
          activity: "Činnost",
          day_drive: "Denní jízda",
          day_rest: "Denní odpočinek",
          week_drive: "Týdenní jízda",
          week_rest: "Týdenní odpočinek",
          twoweeks_drive: "14-denní jízda"
        },
        noactive_suffix: "(neaktuální)"
      }
    }
  },

  "map-preview": {
    size2small: "Změnšit dlaždice",
    size2large: "Zvětšit dlaždice",
    row10: "Omezení na 10 řádků",
    rowall: "Zobrazit všechny vybraná vozidla"
  },

  // rozhraní pro zobrazení a editaci objektu
  data: {
    toolbar: {
      new_record: "Nový záznam",
      record_store: "Uložit záznam",
      record_cancel: "Zrušit úpravu záznamu",
      view_cancel: "Zpět na přehled",
      actions: "Další operace nad záznamem"
    },
    item: {
      new_item: "nový záznam",
      vehicles: "Vozidla",
      persons: "Osoby",
      "special-accesses": "Speciální přístupy",
      groupsets: "Skupiny",
      contracts: "Zakázky",
      subjects: "Společnosti",
      sharings: "Sdílení polohy",
      companies: "Firmy",
      vehicle: "Vozidlo",
      person: "Osoba",
      "special-access": "Speciální přístup",
      groupset: "Skupina",
      contract: "Zakázka",
      subject: "Společnost",
      sharing: "Sdílení polohy",
      company: "Firma",
      deviceConnections: "Připojená vozidla",
      apiConnections: "Připojení uživatelé"
    }
  },

  // pohledy a editace záznamů
  view: {
    leave_msg: "Chcete opravdu zrušit úpravu záznamu. Všechny neuložené změny budou ztraceny.",
    delete_msg: "Opravdu chcete vymazat záznam?<br/>Mazání může trvat dlouho.",
    company: {
      group: {
        base: "Základní parametry",
        perms: "Oprávnění"
      },
      name: "Název",
      code: "Kód",
      country: "Stát",
      active: "Platná firma",
      module_contracts: "Modul zakázek"
    },
    person: {
      group: {
        base: "Základní parametry",
        ids_perms: "Oprávnění a identifikace",
        vehicles: "Povolená vozidla",
        persons: "Povolené osoby",
        companies: "Firmy"
      },
      first_name: "Jméno",
      last_name: "Přijmení",
      login: "Přihlašovací jméno",
      password: "Heslo",
      admin: "Administrátor firmy",
      dispatcher: "Dispečér",
      driver: "Řidič",
      active: "Platná osoba",
      viewall: "Vidí vše",
      role_title: "Role",
      identification_title: "Identifikace",
      add_identification: "Přidat",
      tooltip: {
        id_add: "Přidat identifikaci",
        id_remove: "Vymazat identifikaci"
      }
    },
    "special-access": {
      group: {
        base: "Základní parametry",
        vehicles: "Přidělená vozidla"
      },
      first_name: "Jméno",
      last_name: "Přijmení",
      access: "Typ přístupu",
      login: "Přihlašovací jméno",
      password: "Heslo",
      active: "Platný přístup",
      add_vehicle: "Přidat",
      tooltip: {
        remove_vehicle: "Odebrat vozidlo"
      }
    },
    groupset: {
      group: {
        base: "Základní parametry",
        permission: "Oprávněné osoby (mimo administrátory)",
        vehicles: "Vozidla",
        persons: "Osoby"
      },
      name: "Název",
      note: "Poznámka"
    },
    contract: {
      group: {
        base: "Základní parametry",
        plan: "Plán"
      },
      vehicle: "Vozidlo",
      name: "Název",
      from_ts: "Začíná",
      to_ts: "Končí",
      from_place: "Odkud",
      to_place: "Kam",
      btn_plan: "Plánovat",
      btn_paste: "Vložit",
      btn_clear: "Vymazt"
    },
    subject: {
      group: {
        base: "Základní parametry",
        contacts: "Kontakty"
      },
      country: "Stát",
      name: "Název",
      id: "Identifikace (IČ)",
      vat_number: "Daňová identifikace (DIČ)",
      note: "Poznámka",
      active: "Organizace je aktivní",
      add_contact: "Přidat",
      flag_registered: "registrovaný",
      flag_billing: "fakturační",
      flag_communication: "komunikační",
      tooltip: {
        update_contact: "Upravit kontakt",
        remove_contact: "Odebrat kontakt",
        search: "Vyhledat společnost podle identifikace"
      }
    },
    sharing: {
      group: {
        base: "Základní parametry",
        flags: "Volitelné informace",
        vehicles: "Sdílená vozidla"
      },
      copy: "Kopírovat",
      hash_code: "Přístupový kód",
      valid_from: "Platné od",
      valid_to: "Platné do",
      flag_paninc: "Zobrazovat PANIC stav",
      flag_cargo_door: "Zobrazovat stav dveří nákladu",
      note: "Poznámka",
      add_vehicle: "Přidat",
      tooltip: {
        remove_vehicle: "Odebrat vozidlo"
      }
    },
    vehicle: {
      group: {
        base: "Základní parametry",
        administration: "Administativní údaje",
        technical: "Technické parametry",
        device: "Zařízení",
        measure: "Parametry pro měření",
        ids_tanks: "Identifikace a nádrže",
        tank_title: "Nádrže"
      },
      name: "Název",
      numeric_plate: "SPZ",
      type: "Typ",
      state: "Stav",
      // technické parametry
      consumption_km: "Průměrná spotřeba na l/100km",
      consumption_eh: "Průměrná spotřeba na l/h",
      type_design: "Typové označení",
      category_code: "Kategorie",
      axles: "Nápravy (tučně - celková hmotnost)",
      weight: "Celková hmotnost (v kg)",
      // adminsitrativní údaje
      vin: "VIN",
      technical_licence: "Číslo technického průkazu",
      emission_report: "Číslo emisního protokolu",
      euro_norm_code: "Homologace emisí podle EU",
      manufacture_year: "Rok výroby",
      person: "Odpovědná osoba",
      // device
      device_type: "Typ komunikačního zařízení",
      code: "Jednoznačna identifikace zařízení",
      serialnum: "Seriové číslo",
      install_date: "Nainstalováno",
      installer: "Nainstaloval",
      detectbymotion: "Detekce jízdy pomocí pohybu",
      detectspeed: "Rychlost od které se detekuje jízda v km/h",
      km_gps: "Vzdálenost se měří a tachograf počítá podle GPS",
      join_ival: "Maximální interval čas pro spojení v sekundách",
      split_ival: "Minimální interval s pro rozdělení jízd v sekundách",
      store_ival: "Minimální interval ukládání pozic mimo jízdu a nebo pokud stojí vozidlo na místě (0 - vše, záporné - zakázáno)",
      inactive_tm: "Čas po kterém je vozidlo vedeno jako nekomunikující (v minutách)",
      m_rpm: "Zaznamenávat otáčky",
      m_service_km: "Použít vzdálenost do servisu",
      m_service_date: "Použít čas do servisu",
      // device - dynamické parametry
      pvalues: {
        motorbit: "Pin pro detekci motoru",
        motorbit_none: "Nedetekovat",
        motorbit_pin5: "Pin 5",
        motorbit_pin7: "Pin 7",
        detect_ridetype: "Přepínání jízdy",
        detect_ridetype_0: "Nevyčítat",
        detect_ridetype_30: "Služební/soukromá (ADC3)",
        detect_ridetype_31: "Služební/nakládka-vykládka (ADC3)",
        detect_ridetype_50: "Služební/soukromá (ADC5)",
        detect_ridetype_51: "Služební/nakládka-vykládka (ADC5)",
        none: "Nevyčítat",
        temperature1: "Teplota 1",
        temperature2: "Teplota 2",
        din: "Digitalní vstup {0}",
        panic: "Tlačítko PANIC",
        cargo_door: "Dveře nákladového prostoru"
      },
      // parametry pro měření
      km_start: "Počáteční hodnota tachomeru (v km)",
      eh_start: "Počáteční hodnota motohodin (v h)",
      min_tank_change: "Minimální změna paliva v litrech",
      consumption_min_km: "Standarní minimum spotřeby v l na 100km",
      consumption_max_km: "Standarní maximum spotřeby v l na 100km",
      consumption_min_eh: "Standarní minimum spotřeby v l na mh",
      consumption_max_eh: "Standarní maximum spotřeby v l na mh",
      use_last_driver: "Použít posledního přihlášeného řidiče",
      driver: "Přiřazený řidič k vozidlu",
      rpm_optimum: "Optimální otáčky",
      rpm_max: "Maximální otáčky",
      speed_max: "Maximální rychlost (pro sledování)",
      max_temperature_liquid: "Maximalní teplota chladící kapaliny",
      ft_day: "Den v měsící, kdy se tankuje do plná",
      service_km: "Stav tachometru pro další pravidelný servis",
      service_eh: "Stav motohodin pro další pravidelný servis",
      service_day: "Datum pro další pravidelný servis",
      mot_date: "Datum pro následující STK",
      tachograph_check_date: "Datum pro kontrolu tachografu",
      undefined_tank: "Nedefinována",
      suitable_conditions: "vhodné podmínky",
      tooltip: {
        tank_update: "Upravit nádrž"
      }
    },
    plan: {
      title: "Plán zakázek",
      "show-all": "Zobrazit i vozidla co nemají žádnou zakázku",
      "zoom-month": "Zobrazit celý měsíc",
      "zoom-in": "Zvětšit časovou osu",
      "zoom-out": "Zmenšit časovou osu",
      save: "Uložit plán do souboru",
      "save-png": "Uložit jako obrázek (PNG)",
      "save-pdf": "Uložit jako dokument (PDF)",
      "context-menu": {
        vehicle: {
          "map-vehicle": "Zobrazit vozidlo",
          "map-contracts": "Zákázky vozidla",
          "report-logbook": "Kniha jízd",
          "report-performance": "Výkon vozidla"
        },
        contract: {
          "map": "Zobrazit zakázku na mapě",
          "edit": "Upravit zakázku"
        }
      }
    }
  },

  // tabulky záznamů
  table: {
    vehicles: {
      header: {
        numeric_plate: "SPZ",
        name: "Název",
        type: "Typ",
        imei: "IMEI",
        installDate: "Nainstalováno",
        state: "Stav"
      },
      "context-menu": {
        "map": "Zobrazit na mapě",
        "history": "Zobrazit historii",
        "logbook": "Kniha jízd",
        "refueling": "Tankování",
        "events": "Události",
        "contracts": "Zakázky",
        "service": "Údržba",
        "report-logbook": "Výkaz - Kniha jízd",
        "report-performance": "Výkaz - Výkon vozidla",
        "report-machine-performance": "Výkaz - Výkon stroje",
        "reset-panic": "Zrušit PANIC"
      }
    },
    persons: {
      header: {
        name: "Jméno",
        login: "Přihlašovací jméno",
        roles: "Role",
        ids: "Identifikace"
      },
      "context-menu": {
        "report-tachograph": "Výkaz - Tachograf",
        "report-travel-expenses": "Výkaz - Cestovní náhrady",
        "person-export": "Přidat osobu do jíné firmy"
      }
    },
    "special-accesses": {
      header: {
        name: "Jméno",
        login: "Přihlašovací jméno",
        access: "Typ přístupu"
      }
    },
    groupsets: {
      header: {
        name: "Název",
        note: "Poznámka"
      }
    },
    sharings: {
      header: {
        hash: "Kód",
        from: "Platnost od",
        to: "Platnost do",
        note: "Poznámka"
      },
      "context-menu": {
        "copy-code": "Zkopírovat kód do schránky",
        "copy-url": "Zkopírovat URL do schránky"
      }
    },
    contracts: {
      header: {
        vehicle: "Vozidlo",
        name: "Název",
        subject: "Organizace",
        place_from: "Odkud",
        place_to: "Kam",
        from: "Od",
        to: "Do",
        distance: "Vzdálenost",
        duration: "Doba",
        amount: "Cena",
        amount_km: "Cena za km"
      },
      "context-menu": {
        "show-on-map": "Zobrazit na mapě"
      }
    },
    subjects: {
      header: {
        name: "Název",
        country: "Země",
        id: "Identifikace",
        vat_number: "Daňová identifikace"
      }
    },
    companies: {
      header: {
        name: "Název",
        code: "Kód",
        counry: "Stát",
        created: "Vytvořeno"
      }
    },
    deviceConnections: {
      header: {
        numeric_plate: "SPZ",
        device: "Zařízení",
        ip: "IP",
        connected_from: "Připojeno od",
        packets: "Počet paketů",
        measures: "Počet měření"
      }
    },
    apiConnections: {
      header: {
        user: "Uživatel",
        type: "Typ",
        application: "Klient",
        ip: "IP",
        timestamp: "Poslední komunikace",
        company: "Kód firmy"
      }
    }
  },

  component: {
    login: {
      username: "Uživatelské jméno",
      password: "Heslo",
      permanent: "Trvalé přihlášení",
      confirm: "Přihlásit"
    },
    vehicle_field: {
      title: "Vozidlo"
    },
    vehicles_field: {
      title: "Vozidlo(a)"
    },
    person_field: {
      title: "Osoba"
    },
    subject_field: {
      title: "Organizace",
      new: "Vytvořit novou organizaci"
    },
    period_field: {
      title: "Období",
      from: "Od",
      to: "Do",
      time: "Čas",
      "day-current": "Aktuální den",
      "day-previous": "Předcházející den",
      "day-one": "Den",
      "day-range": "Více dní",
      "day-rangetime": "Více dní (s časem)",
      "month-current": "Aktuální měsíc",
      "month-previous": "Předcházející měsíc",
      "month-one": "Měsíc",
      "month-range": "Více měsíců"
    },
    items_selection: {
      "toggle_fullsreen": "Roztáhnout/zmenšít seznam",
      "inverse_toggle": "Inverzní výběr",
      "inverse_on": "zapnuto",
      "inverse_off": "vypnuto"
    }
  },

  report: {
    close: "Zavřít",
    panel_show: "Zobrazit panel",
    panel_hide: "Zkrýt panel",
    save_as_pdf: "Uložit jako pdf",
    save_as_xlsx: "Uložit jako excel",
    logbook: {
      title: "Kniha jízd",
      filename: "kniha_jízd",
      detailed: "Podrobný výpis",
      "day-summary": "Denní sumář",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Přechody hranic"
    },
    performance: {
      title: "Výkon vozidla",
      filename: "výkon_vozidla",
      detailed: "Podrobný výpis",
      "day-summary": "Denní sumář",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Přechody hranic",
      "category-summary": "Sumář podle různých kategorií"
    },
    "machine-performance": {
      title: "Výkon stroje",
      filename: "výkon_stroje",
      detailed: "Podrobný výpis",
      "day-summary": "Denní sumář",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Přechody hranic"
    },
    "driver-performance": {
      title: "Výkon řidiče",
      filename: "výkon_řidiče",
      detailed: "Podrobný výpis",
      "day-summary": "Denní sumář",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Přechody hranic",
      "vehicle-summary": "Sumář vozidla",
      "show-note": "Zobrazit poznámku"
    },
    temperature: {
      title: "Teplota",
      filename: "teplota",
      granularity: "Seskupovat",
      "remove-empty-rows": "Nezobrazovat prázdné řádky",
      granularities: {
        none: "neseskupovat",
        m15: "po 15 minutách",
        m30: "po 30 minutách",
        m60: "po hodinách"
      }
    },
    tanks: {
      title: "Stav nadrží",
      filename: "stav_nadrží",
      detailed: "Podrobný výpis",
      "day-summary": "Denní sumář",
      "week-summary": "Týdenní sumář",
      "border-crossing": "Přechody hranic"
    },
    tachograph: {
      title: "Tachograf",
      filename: "tachograf",
      weeks_scope: "Týdení statistika",
      days_scope: "Denní statistika",
      scopes: {
        none: "Nezobrazovat",
        base: "Sumární informace",
        graph: "Grafy",
        detail: "Podrobný výpis",
        all: "Vše"
      }
    },
    "travel-expenses": {
      title: "Cestovní náklady",
      ride_border: "Od/do z jizd",
      home_as_abroad: "Domácí cesty jako zahraniční",
      simplified: "Zjednodušený formulář",
      more_params: "Další parametry",
      filename: "cestovani_náklady"
    },
    "vehicles-summary": {
      title: "Statistika vozidel",
      filename: "statistika_vozidel"
    },
    "countries-summary": {
      title: "Statistika podle států",
      filename: "statistika_podle_statu"
    },
    "abroad-summary": {
      title: "Statistika doma/zahraničí",
      filename: "statistika_doma_zahraničí"
    },
    "refuelings": {
      title: "Tankování",
      filename: "tankování"
    },
    "planned-services": {
      title: "Nejbližší plán údržby",
      filename: "nejbližší_plán_údržby"
    },
    "companies-summary": {
      title: "Přehled firem",
      filename: "přehled_firem"
    }
  },

  dialog: {
    company_selection: {
      title: "Výběr firmy",
      filter: "filtr"
    },
    vehicle_selection: {
      title: "Výběr vozidla",
      filter: "filtr"
    },
    groupset_selection: {
      title: "Výběr skupiny",
      filter: "filtr",
      view_all: "Zobrazit vše"
    },
    find_vehicles: {
      title: "Vyhledání vozidla",
      text: "text (min. 3 znaky)"
    },
    identification: {
      title: "Identifikace",
      add: "Přidat",
      type: "Typ",
      code: "Jednoznačný kód"
    },
    tank: {
      title: "Nádrž",
      store: "Uložit",
      remove: "Smazat",
      vehicle_tank_type: "Typ nádrže",
      tank_calc_method: "Způsob získávání stavu",
      fuel_type: "Palivo",
      capacity: "Kapacita nádrže v litrech",
      start_state: "Počáteční stav v litrech",
      need_condition: "Vyžaduje vhodné pomienky pro měření (vozidlo stojí)",
      liter_factor: "Faktor",
      sensor_nvalues: "Převodní tabulka pro senzor"
    },
    contact: {
      title: "Kontakt",
      store: "Uložit",
      remove: "Smazat",
      type: "Typ kontaktu",
      phone: "Telefon",
      email: "Email",
      street: "Ulice",
      house_number: "Číslo domu",
      city: "Obec",
      postal_code: "PSČ",
      country: "Země",
      note: "Poznámka",
      registered: "Registrovaný kontakt (např. statutární adresa)",
      billing: "Fakturační kontakt",
      communication: "Kontakt pro komunikaci"
    },
    vehicle_log: {
      title: "Log",
      log_date: "Vyberte datum"
    },
    not_found: {
      title: "Neplatná stránka"
    },
    confirm: {
      button_cancel: "Zavřít",
      button_ok: "OK",
      button_delete: "Vymazat"
    },
    travel_expenses: {
      tab: {
        base: "Parametry",
        days: "Jednotlivé dny"
      },
      store: "Použít",
      place_from: "Místo začátku cesty",
      place_to: "Místo konce cesty",
      purpose: "Důvod a cíl cesty",
      deposit: "Záloha (v domácí měně)",
      deposit_date: "Záloha vyplacena dne",
      breakfast: "snídaně",
      lunch: "oběd",
      dinner: "večeře"
    },
    refueling: {
      tabs: {
        data: "Vložení dat",
        summary: "Souhrn"
      },
      panels: {
        file: "Ze souboru",
        handy: "Ruční vložení"
      },
      table: {
        "date_time": "Datum",
        "numeric_plate": "SPZ",
        "fuel": "Palivo",
        "quantity": "Množství",
        "amount": "Částka",
        "place": "Místo"
      },
      menu: {
        select: "Zobrazit tankování",
        doc_add: "Přidat doklad",
        doc_update: "Upravit doklad",
        doc_delete: "Smazat doklad"
      },
      parse: "Načíst",
      store: "Vložit",
      add: "Přidat",
      update: "Upravit",
      title_document: "Dokladované tankování",
      vehicle: "Vozidlo",
      place: "Místo tankování",
      date_time: "Datum a čas",
      fuel: "Palivo",
      full: "do plna",
      amount: "Částka",
      quantity: "Množství v litrech",
      file: "Soubor pro import",
      messages: {
        result: "Vložený počet tankování"
      }
    },
    update_vehicle: {
      title: "Úprava provozních parametrů vozidla",
      store: "Uložit"
    },
    update_ride: {
      title: "Úprava jízdy",
      store: "Uložit",
      ride_type: "Typ jízdy",
      driver: "Řidič",
      note: "Krátká poznámka",
      stop_km: "Zarážka tachometru",
      stop_eh: "Zarážka motohodin",
      stop_fix: "zarážka nastavena"
    },
    service_plan: {
      title: "Plán údržby",
      store: "Uložit",
      type_code: "Druh plánu",
      name: "Upřesnění plánu (volitelné)",
      date: "Datum příští údržby",
      period: "Opakovat po (formát {n}r {n}m {n}d)",
      km: "Stav tachometru pro příští údržbu",
      repeated_km: "Opakovat po (v km)",
      eh: "Stav motohodin pro příští údržbu",
      repeated_eh: "Opakovat po (v mh)",
      active: "Plán udržby je aktivní"
    },
    service: {
      title: "Údržba",
      store: "Uložit",
      plan: "Plán údržby",
      type_code: "Druh údržby",
      name: "Upřesnění údržby (volitelné)",
      date: "Datum údržby",
      km: "Stav tachometru",
      eh: "Stav motohodin",
      note: "Poznámka"
    },
    "subject-search": {
      title: "Vyhledávání společností",
      name: "Název",
      id: "Identifikace (IČ)",
      vat_number: "Daňová identifikace (DIČ)",
      address: "Statutární adresa",
      update: "Použít zaškrtlé",
      error: {
        not_found: "Společnost nenalezena",
        gateway_timeout: "Služba pro daný stát je nedostupná",
        country_not_supported: "Vyhledávání společností pro tento stát není podporován",
        invalid_parameter: "Identifikace má neplatný formát"
      }
    }
  },

  error: {
    vehicle_fail: "Vozidlo nekomunikuje",
    optimistic_lock: "Záznam byl během vaší úpravy změněn. Je nutné ho znovu upravit."
  },

  enum: {
    ride_type: {
      "bussines": "služební jízda",
      "private": "soukromá jízda",
      "refueling": "tankování",
      "fuelloss": "úbytek paliva",
      "un-loading": "nakládání/vykládka",
      "loading": "nakládání",
      "unloading": "vykládání"
    },
    vehicle_state: {
      "active": "aktivní",
      "hidden": "skrytý",
      "removed": "vymazaný"
    },
    ride_state: {
      "finished": "ukončená",
      "unfinished": "probíhající"
    },
    vehicle_type: {
      "personal": "osobní vozidlo",
      "truck": "nákladní vozidlo",
      "tractor": "traktor",
      "trailer": "přívěs",
      "semitrailer": "návěs",
      "special": "speciální",
      "machine": "stroj"
    },
    vehicle_category: {
      "M1": "M1",
      "N1": "N1"
    },
    vehicle_norm: {
      "euro1": "Euro 1",
      "euro2": "Euro 2",
      "euro3": "Euro 3",
      "euro4": "Euro 4",
      "euro5": "Euro 5",
      "euro6": "Euro 6",
      "euro7": "Euro 7"
    },
    vehicle_motiondetection: {
      "none": "nedetekovat",
      "speed": "od rychlosti",
      "motion": "od pohybu"
    },
    device_type: {
      "bce": "BCE",
      "bceiotm": "BCE/IOTM"
    },
    vehicle_tank_type: {
      "main": "Hlavní nádrž",
      "heating": "Topení"
    },
    tank_calc_method: {
      "none": "Nezískavájí se",
      "sensor": "Senzor",
      "liter": "CAN v litrech",
      "percent": "CAN v procentech",
      "manual": "Manuální počítání"
    },
    fuel_type: {
      "benzin95": "Naturál 95",
      "benzin98": "Naturál 98",
      "diesel": "Nafta",
      "biodiesel": "Bio nafta",
      "gas": "Plyn"
    },
    tachograph_activity: {
      "0": "Odpočinek/přestávka",
      "1": "Pohotovost",
      "2": "Práce",
      "3": "Jízda",
      "4": "Chyba",
      "5": "Bez karty"
    },
    person_access: {
      "normal": "běžný uživatel",
      "superuser": "super uživatel",
      "collective": "hromadný přístup"
    },
    person_type_ids: {
      "dallas": "dallas/RFID",
      "tachograph": "tachograf"
    },
    parameters: {
      "motor_on": "motor",
      "panic": "panic",
      "cargo_door": "dveře nakladového prostoru"
    },
    service_type: {
      own: "vlastní",
      mot: "STK",
      oil_change: "výměna oleje",
      oil_refill: "doplnění oleje",
      tacho_check: "kontrola tachografu",
      highway_stamp: "dalniční známka",
      warranty_inspection: "garanční prohlídka"
    },
    contact_type: {
      address: "adresa",
      phone: "telefon",
      email: "email"
    }
  },

  param_names: {
    true: {
      "motor_on": "nastartovaný",
      "panic": "aktivní",
      "cargo_door": "otevřené"
    },
    false: {
      "motor_on": "vyplý",
      "panic": "deaktivovaný",
      "cargo_door": "zavřené"
    }
  },

  roles: {
    "superuser": "superuživatel",
    "admin": "administrátor",
    "dispatcher": "dispečer",
    "driver": "řidič",
    "viewall": "vidí vše"
  },

  // importy z jiných knihoven
  $vuetify: cs_vuetify,
  validation: cs_vee
};

lang.validation.messages.decimal = "Pole {_field_} musí být desetiné číslo a počet povolených číslic za desetinou čárkou je {decimals}";
lang.validation.messages.sensor_nvalues = "Pole {_field_} musí být ve formátu: n=číslo;...";

export default lang;